import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';

import logo from '../../logo.svg';

const NotFound = () => {
    return(
        <Container>
            <br/>
            <Row>
                <Col xs={12} sm={12}>
                    <img src={logo} alt="logo-wallpaper" style={{display:'block', width: '100px', height: 'auto', margin:'auto'}} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <p style={{textAlign: 'center', fontSize: '0.9rem'}}>404 - Not Found</p>
                </Col>
            </Row>
        </Container>
    );
}

export default NotFound;